import { Input } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import TestQues from "../../components/testQues/testQues";
import nextQues from "../../helper/nextQues";
import submitQues from "../../helper/submitQues";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import TestFooter from "../testFooter/testFooter";
import "./visualKeypad.scss";
function VisualKeypad({ question, questions, index }) {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();
  const [startTime, setStartTime] = useState();
  const [isInput, setIsInput] = useState(false);
  const [answer, setAnswer] = useState("");
  const { isNextQues } = helperC;

  useEffect(() => {
    setStartTime(moment());
  }, []);

  const getTimeSpend = () => {
    return moment().diff(startTime);
  };

  const handleNext = () => {
    const nextQuesId = questions[index + 1].id;
    nextQues(
      dispatchAnswer,
      dispatchHelper,
      nextQuesId,
      answer,
      getTimeSpend(),
      question
    );
  };

  const handleSubmit = () => {
    submitQues(
      dispatchAnswer,
      dispatchHelper,
      answer,
      getTimeSpend(),
      question,
      answerC.answers,
      null, // answerAudio
      null, // testFormat
      questions,
      helperC.testType
    );
  };

  useEffect(() => {
    if (isNextQues) {
      dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
      index < questions.length - 1 ? handleNext() : handleSubmit();
    }
  }, [isNextQues]);

  useEffect(() => {
    if (!!answer) {
      setIsInput(true);
    } else {
      setIsInput(false);
    }
  }, [answer]);

  return (
    <>
      <div className="test-body">
        <div
          data-aos="zoom-in"
          className="test-body-content visualKeyPad"
          style={{
            justifyContent: helperC.offSetHeight > 100 ? "initial" : "center",
          }}
        >
          <TestQues type="visualKeypad" question={question} />

          <Input
            onChange={(e) => {
              setAnswer(e.target.value);
            }}
            autoFocus
            autoSize={{ minRows: 3, maxRows: 3 }}
            maxlength="200"
            className="input-blk"
          />
        </div>
        <TestFooter
          isUserInput={isInput}
          question={question}
          questions={questions}
          index={index}
        />
      </div>
    </>
  );
}

export default React.memo(VisualKeypad);
